import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import searchTour from 'entities/tour/models/search-tour/search-tour'
import {
  DirectionCardSecondary,
  DirectionCardSecondarySkeleton,
} from 'entities/tour/ui/direction-card-secondary'

import { SearchToursApi, TourSearchDestination } from 'shared/api/tours/search'
import GlassImage from 'shared/images/glasss.png'
import { EmptyPage } from 'shared/ui/empty-page'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const DirectionPage = () => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState<boolean>()
  const [destinations, setDestinations] = useState<TourSearchDestination[]>([])

  const dataForSearchTour = searchTour.getEditableDataForSearchTour()
  const townFromId = dataForSearchTour?.departure?.id

  const getDestination = async () => {
    setIsLoading(true)
    try {
      const { data: countries } =
        await SearchToursApi.getDestinationsCountries()

      setDestinations(countries?.data)
    } finally {
      setIsLoading(false)
    }
  }

  const onClickDirection = (directionId?: string) => {
    const country = destinations?.find(
      (destination) => destination.id === directionId,
    )

    searchTour.setCountryDirection(country)

    if (directionId)
      navigate(RoutingPaths.tours.resortTypePage.path(directionId))
  }

  useEffect(() => {
    if (!townFromId) navigate(RoutingPaths.tours.path())

    void getDestination()
  }, [])

  return (
    <div className="container">
      <HeaderGoBack
        buttonWhite
        title={t('tours_block.to')}
        variant="grey"
      />

      <div className={s.wrapper}>
        <p className={clsx('bold-20', s.directionTitle)}>
          {t('tours_block.countries')}
        </p>

        {isLoading &&
          [...new Array(4)].map((_, index) => (
            <DirectionCardSecondarySkeleton key={index} />
          ))}

        {!isLoading &&
          destinations?.map((destination) => (
            <DirectionCardSecondary
              key={destination.id}
              destination={destination}
              onClick={() => onClickDirection(destination?.id)}
            />
          ))}

        {!isLoading && destinations?.length === 0 && (
          <EmptyPage
            image={GlassImage}
            title={t('empty')}
            subTitle={t('tours_block.empty_desc')}
          />
        )}
      </div>
    </div>
  )
}

export default DirectionPage
